import { render, staticRenderFns } from "./TambahPenerimaanBarangMasuk.vue?vue&type=template&id=343aa2bd&"
import script from "./TambahPenerimaanBarangMasuk.vue?vue&type=script&lang=js&"
export * from "./TambahPenerimaanBarangMasuk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports